import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager } from "../../../../utils";

export const updateProfile = createAsyncThunk('updateProfile', async ({ values }) => {

    var bodyFormData = new FormData()

    bodyFormData.append(
        "id", values.id
    )
    bodyFormData.append(
        "user_name", values.name
    )
    bodyFormData.append(
        "user_code", values.staffid
    )
    bodyFormData.append(
        "mobile_number", values.mobile
    )
    bodyFormData.append(
        "email", values.email
    )
    bodyFormData.append(
        "department_id", values.department
    )
    bodyFormData.append(
        "designation_id", values.designation
    )
    if (values?.profile) {
        bodyFormData.append(
            "profile_photo", values.profile
        )
    }

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'update_profile',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", 'type': 'profile', "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})